import type { NotificationSettings } from "models/NotificationSettings";
import type { AccountCountry } from "modules/bank-accounts";

export interface SettlementScheduleConfig {
  enabled: boolean;
  executeAt: string;
  schedules: [];
  threshold: number;
}

export type { AccountCountry };

export interface CashManagementNotificationSettings
  extends NotificationSettings {}

export interface SettlementBalance {
  amount: number;
}

export interface SettlementLimit {
  limit: number;
}

export const PROPERTY_SANDBOX_ACCOUNT_BALANCE =
  "sandbox.providersAccountBalance";
export const PROPERTY_PRODUCTION_ACCOUNT_BALANCE =
  "production.providersAccountBalance";

export const PROPERTY_PRODUCTION_SETTLEMENT_BALANCE =
  "production.settlementBalance";

export const PROPERTY_SANDBOX_SETTLEMENT_BALANCE = "sandbox.settlementBalance";

export const PROPERTY_PRODUCTION_SETTLEMENT_SCHEDULE_CONFIG =
  "production.settlementScheduleConfig";

export const PROPERTY_SANDBOX_SETTLEMENT_SCHEDULE_CONFIG =
  "sandbox.settlementScheduleConfig";

export const PROPERTY_PRODUCTION_SETTLEMENT_CONFIGURATION =
  "production.settlementConfiguration";

export const PROPERTY_SANDBOX_SETTLEMENT_CONFIGURATION =
  "sandbox.settlementConfiguration";

export type {
  CashManagementAccount,
  CashManagementProviderAccount,
} from "modules/connect";
